import { computed, watch, ref } from "vue";

export function generateTiersObject(tiers) {
  return (
    tiers
      ?.toSorted((a, b) => a.min - b.min)
      // eslint-disable-next-line max-params
      .reduce((acc, current, i, array) => {
        const next = i < array.length - 1 ? array[i + 1] : null;
        if (next) {
          acc.push({
            range: `$${current.min} - $${(next.min - 0.01).toFixed(2)}`,
            min: current.min,
            max: next.min - 0.01,
            percentage: current.rate * 100
          });
        } else {
          acc.push({
            range: `Above $${current.min}`,
            min: current.min,
            max: Number.MAX_SAFE_INTEGER,
            percentage: current.rate * 100
          });
        }
        return acc;
      }, [])
  );
}

export default function useTransfersStoreCredit() {
  const storeCreditInfo = ref(null);

  const creditAmount = computed(() =>
    Number(storeCreditInfo.value?.userStoreCredits?.transfers?.totalAmount ?? 0)
  );

  const orderSubtotal = computed(() =>
    Number(storeCreditInfo.value?.orderSubtotal ?? 0)
  );

  const expectedCredits = computed(() =>
    Number(storeCreditInfo.value?.expectedCredits ?? 0)
  );

  const transfersCartSubtotal = computed(() =>
    Number(storeCreditInfo.value?.transfersCartSubtotal ?? 0)
  );

  const tiers = computed(() =>
    generateTiersObject(storeCreditInfo.value?.tiers ?? [])
  );

  const totalCartAmount = computed(() =>
    orderSubtotal.value + transfersCartSubtotal.value
  );

  const currentTier = computed(() => {
    if (!tiers.value?.length) return null;
    const lastTier = tiers.value[tiers.value.length - 1];
    return tiers.value.find(tier => totalCartAmount.value <= tier.max) || lastTier;
  });

  const currentExpectedCredits = computed(() => {
    let total = 0;
    if (currentTier.value) {
      const multiplier = currentTier.value.percentage / 100;
      total = totalCartAmount.value * multiplier;
    }
    return total;
  });

  const updateStoreCreditInfo = (newInfo) => {
    storeCreditInfo.value = newInfo;
  };

  return {
    storeCreditInfo,
    creditAmount,
    orderSubtotal,
    expectedCredits,
    transfersCartSubtotal,
    tiers,
    totalCartAmount,
    currentTier,
    currentExpectedCredits,
    updateStoreCreditInfo
  };
}